import React, { useState } from 'react';
import _ from 'lodash';
import { Notification } from './Notification';
import { useApiQuery } from '../utils/apiHooks';
import { ApiRequest } from '../utils/api';

interface Props {
	path: string;
}

export const TopNotifications: React.FC<Props> = (props: Props) => {
	// If fetching notifications fails, we don't need to show user any error message
	const { data } = useApiQuery(ApiRequest.getNotifications(), { onError: (e: any) => {} });
	const [hiddenNotications, setHiddenNotifications] = useState<number[]>([]);

	const showByPath = (notification: any) =>
		(notification.id === 'b2b-munmoi-sim-page' && props.path.includes('/account/sims/')) ||
		(notification.id === 'yritysmoi-login-page' && props.path.includes('/login')) ||
		notification.id === 'b2b-munmoi-all-pages';

	const closeNotification = (identifier: number) => {
		setHiddenNotifications(hiddenNotications.concat(identifier));
	};

	const visible = data !== undefined ? data.notifications.filter(showByPath).filter((notification) => !_.includes(hiddenNotications, notification.identifier)) : [];
	return (
		<div>
			{visible.map((notification, key) => (
				<Notification notification={notification} key={key} orderNumber={key} closeNotification={closeNotification} />
			))}
		</div>
	);
};
